






import { Vue } from 'vue-property-decorator';

export default class LoadingCover extends Vue {}
